module.exports = __webpack_public_path__ + "static/img/relief01.ee4db46.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/relief01.bmp
// module id = OpKt
// module chunks = 2